import { Component, ErrorInfo, ReactNode } from 'react';

export interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='error-boundary-container' style={{ textAlign: 'center', padding: '4rem 1rem' }}>
          <h1>Error al cargar la página</h1>
          <p>No fue posible cargar la página solicitada, por favor intente otra vez.</p>
          <button onClick={() => (window.location.href = '/')}>Volver al inicio</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
